import { Injectable } from '@angular/core';

import { ServiceEnvironment } from '../../auto-suggest/search-page-bootstrapper/search-page-bootstrapper.service';
import { ConfigParserService } from '../../shared/services/config-parser.service';

export interface SearchConfig {
    appResultsInConsumerSerpEnabled: boolean;
    clientSideRelevanceEnabled: boolean;
    disableSearchEnterPressedAction: boolean;
    enableConsumerSearchExactMatchRanker: boolean;
    premiumTemplatesForSearchEnabled: boolean;
    fastAutoSuggestionBookmarksEnabled: boolean;
    fastAutoSuggestionFileSecondaryTextEnabled: boolean;
    fastBingAnswerResultsEnabled: boolean;
    fastODCFileProviderEnabled: boolean;
    fastSearchUXEnvironment: string;
    fastUseEcsSettingsOverride: boolean;
    fastUseSubstrateEnabled: boolean;
    fastUseSubstrateSearchSingleQueryEnabled: boolean;
    fastDisableStarQuery: boolean;
    helpProviderInCommercialEnabled: boolean;
    resources: SearchResources;
    learningProviderEnabled: boolean;
    searchInHeaderEnabled: boolean;
    templatePreviewProviderWithNoThumbnails: boolean;
    templatePreviewProviderWithSeeMoreEnabled: boolean;
    templateProviderInCommercialEnabled: boolean;
    typeToSearchEnabled: boolean;
    fastEnableQueryRules: boolean;
    serpSpellCheckEnabled: boolean;
    settingProviderEnabled: boolean;
    goToProviderEnabled: boolean;
    complianceEnvironment: ServiceEnvironment;
    searchEnvironmentUrls: string;
    useSimpleRequest: boolean;
    fetchPersonalData: boolean;
    microsoftSearchBootstrapperUrlOverridesEnabled: boolean;
    useThorEnabled: boolean;
    microsoftSearchBootstrapperKillSwitchesActive: string;
    useUpnInLpc: boolean;
    microsoftSearchDisableConfigurationBeforeSearchLoggerEnabled: boolean;
}

// Used for consumer office.com search suggestions.
export interface SearchResources {
    BrandAccess: string;
    BrandHighLander: string;
    BrandSharePoint: string;
    BrandTeams: string;
    BrandPowerBI: string;
    BrandPublisher: string;
    BrandProject: string;
    BrandSkypeForBusiness: string;
    BrandStream: string;
    BrandVisio: string;
    ConsumerSearchBoxStringExperimentA: string;
    ConsumerSearchBoxCustomString: string;
    SearchBoxClearButtonLabel: string;
    SearchBoxMagnifierSubmitButtonLabel: string;
    SearchSuggestionAppHeading: string;
    SearchSuggestionBingButtonText: string;
    SearchSuggestionBingHeading: string;
    SearchSuggestionFileHeading: string;
    SearchSuggestionFileTypeNarratorText: string;
    SearchSuggestionHelpHeading: string;
    SearchSuggestionGoToHeading: string;
    SearchSuggestionGoToLabelInSerp: string;
    SearchSuggestionGetAppForBusinessText: string;
    SearchSuggestionGetAppForFamilyText: string;
    SearchSuggestionLearningAriaLabel: string;
    SearchSuggestionOneDriveHeading: string;

    /* Learnings for Template Preview provider.
     * Button text: Try typing "{0}".
     * {0} is replaced with a contextText.
     */
    SearchSuggestionLearningButtonText1: string;
    SearchSuggestionLearningContentText1: string;
    SearchSuggestionLearningContentText2: string;
    SearchSuggestionLearningContentText3: string;

    SearchSuggestionSeeMoreText: string;
    SearchSuggestionSeeMoreButtonText: string;
    SearchSuggestionSeeMoreHeading: string;
    SearchSuggestionSerpButtonText: string;
    SearchSuggestionTemplateButtonText: string;
    SearchSuggestionTemplateSeeMoreButtonText: string;
    SearchSuggestionTemplateHeading: string;
    SettingSearchBuyOrRenewOfficeText: string;
    SettingSearchEnterProductKeyText: string;
    SettingSearchFamilyText: string;
    SettingSearchInstallOfficeText: string;
    SettingSearchManageDevicesText: string;
    SettingSearchMyAccountText: string;
    SettingSearchMyProfileText: string;
    SettingSearchRedeemGiftCardText: string;
    SubmitSearchSuggestionLabel: string;
}

@Injectable({
    providedIn: 'root'
})
export class SearchConfigService {
    public readonly config: SearchConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<SearchConfig>('searchConfig');
        if (this.config) {
            this.config.searchInHeaderEnabled = this.config.searchInHeaderEnabled;
        }
    }
}
